// const host_dev = 'http://192.168.110.239:10012';//开发以'/'本地localhost发起
const host_dev = 'https://app.yimoubi.com';//开发以'/'本地localhost发起
const host_prod = 'https://app.yimoubi.com';
// const host_prod = 'http://oa.supperblog.top';

// 根据 process.env.NODE_ENV 判断 开发或生产接口地址
const host = process.env.NODE_ENV == 'development' ? host_dev : host_prod;

// 后台各个服务地址头
// const hostV1 = host + '/v1';
// const hostV2 = host + '/v2';
// const hostV3 = host + '/v3';
// const hostV4 = host + '/v4';
const urls = {
  login: '/server/login/login',
  loaduser: '/server/login/loaduser',
  getshoplist: '/server/mine/getshoplist',
  addshop: '/server/mine/addshop',
  delshop: '/server/mine/delshop',
  editshop: '/server/mine/editshop',
  zongheZhibiao: '/server/caiwu/zongheZhibiao',
  zongheZhibiaoEchart: '/server/caiwu/zongheZhibiaoEchart',
  lirunribao_excel: '/server/jingying/lirunribao_excel',
  lirunribao_zhifu: '/server/jingying/lirunribao_zhifu',
  lirunribao_zhifu_echart: '/server/jingying/lirunribao_zhifu_echart',
  lirunribao_fahuo: '/server/jingying/lirunribao_fahuo',
  lirunribao_fahuo_echart: '/server/jingying/lirunribao_fahuo_echart',
  changepassword: '/server/login/changepassword',
  changephone: '/server/login/changephone',
  changeuser: '/server/login/changeuser',
  getgoodsrolelist: '/server/template/getgoodsrolelist',
  addgoodslist: '/server/template/addgoodslist',
  addgoodsrolelist: '/server/template/addgoodsrolelist',
  lirunribao_qudao: '/server/jingying/lirunribao_qudao',
  lirunribao_dianpu: '/server/jingying/lirunribao_dianpu',
  lirunribao_goods: '/server/jingying/lirunribao_goods',
  lirunribao_sku: '/server/jingying/lirunribao_sku',
  templategetshoplist: '/server/template/getshoplist',
  setShopXiaoshou: '/server/template/setShopXiaoshou',
  getuserxiaoshoulist: '/server/template/getuserxiaoshoulist',
  setUserXiaoshou: '/server/template/setUserXiaoshou',
  getorderlist: '/server/index/getorderlist',
  delOrder: '/server/index/delOrder',


  getZhangdanList: '/server/index/getZhangdanList',
  delZhangdan: '/server/index/delZhangdan',


  importorders: '/server/index/importorders',
  uploadFile: '/server/index/uploadFile',
  getgoodslist: '/server/template/getgoodslist',
  importZhangdans: '/server/index/importZhangdans',
  getTuiguangList: '/server/index/getTuiguangList',
  delTuiguang: '/server/index/delTuiguang',


  importTuiguangs: '/server/index/importTuiguangs',
  setspecialorders: '/server/index/setspecialorders',

  getXianxiaList: '/server/index/getXianxiaList',
  delXianxia: '/server/index/delXianxia',


  importXianxia: '/server/index/importXianxia',
  importjdshouhuobiao: '/server/index/importjdshouhuobiao',
  getjdshouhuolist: '/server/index/getjdshouhuolist',
  delJDShouhuo: '/server/index/delJDShouhuo',


  importshouhuobiao: '/server/index/importshouhuobiao',
  getshouhuobiaolist: '/server/index/getshouhuobiaolist',
  delShouhuo: '/server/index/delShouhuo',


  updateprice: '/server/template/updateprice',
  updatekuaidi: '/server/template/updatekuaidi',
  updatezengpin: '/server/template/updatezengpin',
  gettemplatelist: '/server/template/gettemplatelist',
  addkuaidirole: '/server/template/addkuaidirole',
  updatezhongliang: '/server/template/updatezhongliang',
  updatebaozhuang: '/server/template/updatebaozhuang',
  getuserlist: '/server/template/getuserlist',
  addzequan: '/server/template/addzequan',
  getzequanlist: '/server/template/getzequanlist',
  addendzequan: '/server/template/addendzequan',
  delzequan: '/server/template/delzequan',
  lirunribao_usershang: '/server/jingying/lirunribao_usershang',
  lirunribao_userxia: '/server/jingying/lirunribao_userxia',
  addbaozhuangzengpintemplate: '/server/template/addbaozhuangzengpintemplate',

  initZongheZhibiao: '/server/template/initZongheZhibiao',
  getZhibiaoList: '/server/template/getZhibiaoList',
  editZhibiao: '/server/template/editZhibiao',


  importjdshouhuobiao: '/server/index/importjdshouhuobiao',
  getjdshouhuolist: '/server/index/getjdshouhuolist',


  shouzhiList: '/server/template/shouzhiList',
  getRiqi: '/server/template/getRiqi',
  addShouzhi: '/server/template/addShouzhi',


  getindexUserList: '/server/index/getUserList',
  changeindexuser: '/server/index/changeuser',
  ManagerRoles: '/server/index/ManagerRoles',
  addManagerRoles: '/server/index/addManagerRoles',
  getManagerAllMenu: '/server/index/getManagerAllMenu',
  ManagerRoutes: '/server/index/ManagerRoutes',
  addManagerMenu: '/server/index/addManagerMenu',
  editManagerMenu: '/server/index/editManagerMenu',
  deleteManagerMenu: '/server/index/deleteManagerMenu',
  editManagerRoles: '/server/index/editManagerRoles',
  deleteManagerRoles: '/server/index/deleteManagerRoles',
  createuser: '/server/index/createuser',
  getMenuByroles: '/server/index/getMenuByroles',

  mubiaoZhuizong: '/server/jingying/mubiaoZhuizong',
  mubiaoZhuizong_echart: '/server/jingying/mubiaoZhuizong_echart',
  kemufeiyong: '/server/jingying/kemufeiyong',
  shouzhiMobanList: '/server/template/shouzhiMobanList',
  delShouzhi: '/server/template/delShouzhi',
  delShouzhiMoban: '/server/template/delShouzhiMoban',
  delGoods: '/server/template/delGoods',

  lirunribao_teshu: '/server/jingying/lirunribao_teshu',
  lirunribao_teshuexcel: '/server/jingying/lirunribao_teshuexcel',




}

export default urls;



// WEBPACK FOOTER //
// ./src/http/urls.js